import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { QueryString } from '@grandvisionhq/utils';
import { useRoutingContext } from '../../pages/BookAppointment/context/RoutingContext/context.js';
import SignInBox from './SignInBox.js';

const SignInBoxContainer = (props)=>{
    const { hasLabel , getLabel  } = useIntl();
    const [, { basePath , signInMyAccountUrl , queryParams  }] = useRoutingContext();
    const labels = React.useMemo(()=>({
            haveAnAccount: getLabel('appointments.selectionSteps.details.haveAnAccount'),
            signIn: getLabel('appointments.selectionSteps.details.signIn'),
            addInfo: hasLabel('appointments.selectionSteps.details.addInfo') ? getLabel('appointments.selectionSteps.details.addInfo') : undefined
        })
    , [
        hasLabel,
        getLabel
    ]);
    const signInUrl = React.useMemo(()=>{
        const origin = typeof window === 'undefined' ? '' : window.location.origin;
        return `${origin}${signInMyAccountUrl}?returnPath=${basePath}/who${encodeURIComponent(QueryString.stringify(queryParams))}`;
    }, [
        basePath,
        signInMyAccountUrl,
        queryParams
    ]);
    return /*#__PURE__*/ React.createElement(SignInBox, swcHelpers.extends({}, props, {
        labels: labels,
        signInUrl: signInUrl
    }));
};
var SignInBoxContainer$1 = SignInBoxContainer;

export { SignInBoxContainer$1 as default };
//# sourceMappingURL=SignInBoxContainer.js.map
